export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook("app:beforeMount", async () => {
        const {parseFetch} = useProductStore();
        await parseFetch();
    });
});
